module.exports = __webpack_public_path__ + "img/lcbz3.62580f5e.png";